import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSubstack: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconSubstack"><Path d="M19.9993 7.11905H4V9.28019H19.9993V7.11905Z" fill="currentColor"/><Path d="M4 11.2381V21.286L11.9993 16.7986L20 21.286V11.2381H4Z" fill="currentColor"/><Path d="M19.9993 3H4V5.16078H19.9993V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSubstack;
